var hideGladlyAndCookieConcent = function hideGladlyAndCookieConcent(hide) {
  var gladly = document.getElementById('gladlyChat_container');
  var cookie = document.getElementById('ot-sdk-btn-floating');
  if (hide && gladly && cookie) {
    gladly.style.visibility = 'hidden';
    cookie.style.visibility = 'hidden';
  } else if (gladly && cookie) {
    gladly.style.visibility = 'visible';
    cookie.style.visibility = 'visible';
  }
};
export default hideGladlyAndCookieConcent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/utils/hideGladlyAndCookieConcent.js
// module id = 4599
// module chunks = 11